import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Refresh from '@material-ui/icons/Refresh';
import Clear from '@material-ui/icons/Clear';
import ExitToApp from '@material-ui/icons/ExitToApp';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { DateAndTime, ConfirmDialog } from '../../components';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Hidden from '@material-ui/core/Hidden';
import MaterialUIAppBar from '@material-ui/core/AppBar';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import SubheaderPanel from '../../components/subheader-panel';
import ButtonBadge from '../../components/button-badge';
import PopUpMenu from '../../components/popupmenu';

import FullscreenEnableIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';

class AppBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLogoutConfirm: false,
    };
  }

  renderSearchBar() {
    const {
      classes,
      setOrderSearchValue,
      orderSearchValue,
    } = this.props;

    return (
      <div className={classes.searchBar}>
        <TextField
          placeholder="Suche (Abholnr. / Name)"
          value={orderSearchValue || ''}
          onChange={e => setOrderSearchValue(e.target.value)}
          style={{ flexGrow: 1 }}
          InputProps={{
            classes: { root: 'search-bar-input' },
            endAdornment: orderSearchValue && (
              <InputAdornment position="end">
                <IconButton onClick={() => setOrderSearchValue()}><Clear /></IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
    );
  }

  renderAppbar() {
    const {
      classes,
      signalRconnected,
      toggleFullScreen,
      isFullScreen,
      showToggleFullScreenButton,
      user,
    } = this.props;

    const refreshPage = () => {
      window.location.reload();
    };

    const renderRefreshButton = () => (
      <IconButton
        fontSize="default"
        className={classes.iconButton}
        onClick={refreshPage}
      >
        <Refresh />
      </IconButton>
    );

    const renderFullScreenButton = () => (
      (showToggleFullScreenButton && !this.props.isInApp) ? (
        <div className="hide-fullscreen">
          <IconButton
            fontSize="default"
            className={classes.iconButton}
            onClick={toggleFullScreen}
          >
            {
              isFullScreen ?
                <FullscreenExitIcon />
                :
                <FullscreenEnableIcon />
            }
          </IconButton>
        </div>
      ) : null
    );

    const signalRWarning = false && signalRconnected === false
      ? (<div onClick={window.location.reload}>
        <Typography color="inherit">Verbindungsprobleme zu smorder</Typography>
      </div>)
      : null;

    return (
      <MaterialUIAppBar
        position="sticky"
        color="secondary"
        classes={{ root: 'app-bar' }}
      >
        <div>
          <PopUpMenu
            logoutFunc={() => this.setState({ showLogoutConfirm: true })}
            user={user}
          />
          <div>{signalRWarning}</div>
        </div>

        <div className="right-part">
          <div className="search-and-buttons">
            {this.renderSearchBar()}
            {renderRefreshButton()}
            {renderFullScreenButton()}
          </div>

          <div className="date-and-time">
            <DateAndTime />
          </div>
        </div>
      </MaterialUIAppBar>
    );
  }

  render() {
    return (
      <div>
        {this.renderAppbar()}
        <SubheaderPanel />

        <ConfirmDialog
          open={this.state.showLogoutConfirm}
          title="Sind Sie sicher?"
          message="Sie werden nun aus dem System ausgeloggt"
          onDismiss={() => this.setState({ showLogoutConfirm: false })}
          onAgree={() => {
            this.setState({ showLogoutConfirm: false });
            this.props.logout();
          }}
        />
      </div>
    );
  }
}


const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    'box-shadow': '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    backgroundColor: theme.backgroundcolor,
  },
  titleText: {
    fontSize: '1.23rem',
    margin: '5px',
  },
  // error: {
  //   background: theme.palette.error.dark,
  // },
  // dateAndTimeWrapper: {
  //   flex: '0 0 auto',
  // },
  warningTextWrapper: {
    flex: '1',
    padding: 10,
    color: theme.palette.error.contrastText,
  },
  button: {
    marginRight: 10,
    fontSize: theme.appbar.buttons.fontSize,
  },
  iconButton: {
    margin: 0,
    padding: 5,
    // marginRight: 10,
    // border: '1px solid rgba(0,0,0,0.23)',
  },
  moreDayButton: {
    display: 'inline',
  },
  searchBar: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    flexGrow: 1,
    maxWidth: '450px',
  },
  logoutIcon: {
    color: 'black',
  },
});

AppBar.propTypes = {
  selectedMode: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  signalRconnected: PropTypes.bool,
  setMode: PropTypes.func.isRequired,
  ordersStartDate: PropTypes.object.isRequired,
  preOrderDaysAheadAllowed: PropTypes.number.isRequired,
  orderSearchValue: PropTypes.string,
  setOrderSearchValue: PropTypes.func,
  logout: PropTypes.func,
  toggleFullScreen: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  showToggleFullScreenButton: PropTypes.bool.isRequired,
};

AppBar.defaultProps = {
  signalRconnected: null,
  ordersStartDate: null,
  orderSearchValue: null,
  setOrderSearchValue: () => { },
  logout: () => { },
};


export default withStyles(styles)(AppBar);
